import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../assets/logo.png";
import constants from "config/constants";
import ScrollTopLink from "./ScrollTopLink";
import ExternalTabLink from "./ExternalTabLink";
import { useRedirectTo } from "hooks/useRedirectTo";

function Footer() {
  const { createRedirectUrl } = useRedirectTo();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          {/* Left */}
          <div className="footer-left">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <img src={logo} alt="Hua Shen Herbs logo" />
              </div>
              <div className="footer-logo-text">
                <h3>Hua Shen Herbs</h3>
                <span>Brittany Finnegan, MPH, L.Ac.</span>
              </div>
            </div>

            <hr className="footer-divider" />

            <div className="footer-contact">
              <a
                className="contact-item"
                href={`tel:${constants.contact.phoneNumber}`}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M22 16.92V19a2 2 0 01-2.18 2 19.86 19.86 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.86 19.86 0 01-3.07-8.67A2 2 0 014.11 2h2.09a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9a16 16 0 006 6l.4-.4a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0121 16.92z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    fill="none"
                  />
                </svg>
                <span>{constants.contact.phoneNumber}</span>
              </a>
              <a
                className="contact-item"
                href={`mailto:${constants.contact.emailAddress}`}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    fill="none"
                  />
                  <polyline
                    points="22,6 12,13 2,6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    fill="none"
                  />
                </svg>
                <span>{constants.contact.emailAddress}</span>
              </a>
              <div className="contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    fill="none"
                  />
                  <circle
                    cx="12"
                    cy="10"
                    r="3"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    fill="none"
                  />
                </svg>
                <span>{constants.contact.officeAddress}</span>
              </div>
            </div>

            <hr className="footer-divider" />

            <div className="footer-social">
              <a
                href={constants.socialLinks.instagram}
                className="social-link"
                aria-label="Instagram"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path
                    d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"
                    fill="#112314"
                  />
                  <line
                    x1="17.5"
                    y1="6.5"
                    x2="17.51"
                    y2="6.5"
                    stroke="#112314"
                    strokeWidth="2"
                  />
                </svg>
              </a>
              <a
                href={constants.socialLinks.facebook}
                className="social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M24 12.07C24 5.41 18.63.07 12 .07S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.32l-.53 3.5h-2.8V24C19.62 23.1 24 18.1 24 12.07" />
                </svg>
              </a>
              <a
                href={constants.socialLinks.youtube}
                className="social-link"
                aria-label="YouTube"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M23.5 6.2s-.23-1.63-.94-2.35c-.9-.94-1.91-.95-2.37-1C17.3 2.68 12 2.68 12 2.68s-5.3 0-8.19.17c-.46.05-1.47.06-2.37 1-.71.72-.94 2.35-.94 2.35S.32 8.11.32 9.99v1.77c0 1.88.18 3.79.18 3.79s.23 1.63.94 2.35c.9.94 2.08.91 2.6.1 1.89.18 7.96.24 7.96.24s5.32-.01 8.21-.18c.46-.05 1.47-.06 2.37-1 .71-.72.94-2.35.94-2.35s.18-1.91.18-3.79V9.99c0-1.88-.18-3.79-.18-3.79zM9.6 14.5V8.8l6.4 2.85-6.4 2.85z" />
                </svg>
              </a>
              <a
                href={constants.socialLinks.tikTok}
                className="social-link"
                aria-label="TikTok"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M14.27 3h3.09c.13 1.09.69 2.12 1.55 2.82.86.7 1.96 1.02 3.09.91v3.19c-1.44.02-2.85-.4-4.06-1.2v6.08c0 3.8-3.09 6.89-6.89 6.89s-6.89-3.09-6.89-6.89 3.09-6.89 6.89-6.89c.24 0 .49.01.73.04v3.38a3.47 3.47 0 00-.73-.08 3.55 3.55 0 100 7.1 3.55 3.55 0 003.55-3.55V3z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Right */}
          <div className="footer-right">
            <nav className="footer-nav">
              <h4>Navigation Links</h4>
              <ul className="footer-nav-list">
                <li>
                  <ScrollTopLink to="/">Home</ScrollTopLink>
                </li>
                <li>
                  <ScrollTopLink to="/about">About</ScrollTopLink>
                </li>
                <li>
                  <ScrollTopLink to="/contact">Contact</ScrollTopLink>
                </li>
                <li>
                  <Link to={createRedirectUrl("")}>Dashboard</Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Hua Shen Herbs. All rights reserved.
          </p>
          <div className="footer-links">
            <ExternalTabLink to="/terms-and-conditions">
              Terms of Use
            </ExternalTabLink>
            <ExternalTabLink to="/privacy-policy">
              Privacy Policy
            </ExternalTabLink>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
